document.addEventListener('DOMContentLoaded', () => {
  // .open-modal-link: description links that lost data-modal fall back to the sizing guide
  document.querySelectorAll('[data-modal], .open-modal-link').forEach((opener) => {
    opener.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent default behavior for links or buttons

      const modalId = opener.getAttribute('data-modal') || '#PopupModal-measurements'; // Get the modal ID

      const modal = document.querySelector(modalId); // Find the modal element

      if (modal && typeof modal.show === 'function') {
        modal.show(opener); // Trigger the modal's show method
      } else {
        console.error(`Modal with ID ${modalId} not found or not a valid modal element.`);
      }
    });
  });
});
